import { type QueryOptions } from '@tanstack/query-core'

import { type CustomerEntity } from '@/libs/api'
import { type CustomersOrder } from '@/libs/api/types'

import { fetchCustomers } from '../api'
import { customersQueryKeys } from '../query-keys'

/**
 * Select用の荷主一覧のQueryOptionsを返す
 */
export const getCustomersSelectQueryOptions = (
  tenantKey: string,
  dcIds?: number[],
  orders?: CustomersOrder[],
  shippingDate?: string
): Required<Pick<QueryOptions<CustomerEntity[]>, 'queryKey' | 'queryFn'>> => {
  return {
    queryKey: customersQueryKeys.select(tenantKey, {
      dcIds,
      orders,
      shippingDate
    }),
    queryFn: async ({ signal }) => {
      const { data } = await fetchCustomers(
        {
          tenantKey,
          query: {
            page: -1, // 全件取得するために-1を指定
            enable: true,
            dcIds,
            orders,
            shippingDate
          }
        },
        signal
      )
      return data
    }
  }
}
